import { Dispatch } from 'redux';
import { getAnnualEnrollmentInfo, getAnnualEnrollmentStatus, postAnnualEnrollment } from '../../../global/ducks/mlps-api';
import { YesNoIndicators } from '../../../global/models/api-model';
import { DemographicAppKeys } from '../../../global/models/demographics-model';
import { createNewForm } from '../../arc/constants/constant-strings';
import { DeclinedValue } from '../../arc/features/new-hire-enrollment/enrollment/models/coverage-models';
import { setAEInfo } from '../annual-enrollment-slice';
import { AnnualEnrollmentFormValues } from '../models/annual-enrollment-form-models';
import { AEInfo, AnnualEnrollmentState, ProcessingStatus } from '../models/annual-enrollment-models';

export function deleteWorkflow(dispatch: Dispatch<any>, app: DemographicAppKeys, guid: string, aeInfo: AEInfo, groupId?: number) {
	const abandonPayload = {
		form_info: {
			change_id: aeInfo?.form_info?.change_id,
			change_id_signature: aeInfo?.form_info?.change_id_signature,
			workflow_action: 'Delete',
		},
	};

	dispatch(postAnnualEnrollment(
		guid,
		abandonPayload,
		(response) => {
			if (response?.api_response?.status === 'OK') {
				dispatch(dispatch(setAEInfo(response, app)));
			}

		},
		null,
		groupId,
	));
}

export function fetchAnnualEnrollment(dispatch: Dispatch<any>, app: DemographicAppKeys, guid: string, skipStatus?: boolean, groupId?: number) {


	dispatch(getAnnualEnrollmentStatus(guid, (statusResponse) => {
		const status = statusResponse?.form_record?.processing_category;

		const manualNewFormInProgress = sessionStorage?.getItem(`${createNewForm}-${guid}`);

		const completedStatus =
			(status === ProcessingStatus.Completed) &&
				(app === DemographicAppKeys.myCPG && statusResponse?.form_record.processing_substatus !== ProcessingStatus.Abandon) &&
				!skipStatus &&
				manualNewFormInProgress !== YesNoIndicators.Yes
				? 1 : 0;

		dispatch(getAnnualEnrollmentInfo(
			guid,
			completedStatus,
			(getResponse) => {
				const aeInfoResponse = getResponse as AEInfo;

				if (aeInfoResponse?.form_record?.processing_status === ProcessingStatus.Active) {
					deleteWorkflow(dispatch, app, guid, aeInfoResponse, groupId);
				} else {
					dispatch(setAEInfo(getResponse, app));
				}
			},
			null,
			groupId,
		));
	}));
}


export function verifyAndSubmitAnnualEnrollment(dispatch: Dispatch<any>, app: DemographicAppKeys, guid: string, values: AnnualEnrollmentFormValues, aeState: AnnualEnrollmentState, callBack: () => void, groupId?: number) {
	const effectiveDate = aeState.AEInfo?.ae_status?.effective_date;

	const dependents = aeState.AEInfo?.eligible_dependents;

	const dependentsPayload = {};
	for (let i = 0; i < dependents?.length; i += 1) {
		const dependentGuid = dependents[i]?.person._guid;

		dependentsPayload[dependentGuid] = {
			M: values.M.includes(dependentGuid) ? YesNoIndicators.Yes : YesNoIndicators.No,
			D: values.D.includes(dependentGuid) ? YesNoIndicators.Yes : YesNoIndicators.No,
		};
	}

	// use defaults if coverage was declined before, and it is staying declined
	const medicalKeepDeclined = values.medicalPlan === DeclinedValue && !aeState?.AEInfo?.ae_defaults?.medical_default_plan;
	const medicalEdited = !medicalKeepDeclined && values.medicalPlan !== aeState?.AEInfo?.ae_defaults?.medical_default_plan
		? [{
			code: values.medicalPlan === DeclinedValue ? '' : values.medicalPlan,
			effective_date: effectiveDate,
			termination_date: values.medicalPlan !== DeclinedValue ? '' : effectiveDate,
		}]
		: aeState?.AEInfo?.enrollments_base?.M || [];

	const dentalKeepDeclined = values.dentalPlan === DeclinedValue && !aeState?.AEInfo?.ae_defaults?.dental_default_plan;
	const dentalEdited = !dentalKeepDeclined && values.dentalPlan !== aeState?.AEInfo?.ae_defaults?.dental_default_plan
		? [{
			code: values.dentalPlan === DeclinedValue ? '' : values.dentalPlan,
			effective_date: effectiveDate,
			termination_date: values.dentalPlan !== DeclinedValue ? '' : effectiveDate,
		}]
		: aeState?.AEInfo?.enrollments_base?.D || [];

	const verifyPayload = {
		form_info: {
			change_id: aeState.AEInfo?.form_info?.change_id,
			change_id_signature: aeState.AEInfo?.form_info?.change_id_signature,
			workflow_action: 'Verify',
		},
		global_edited: {
			memo: values.memo,
			special_requests: values.specialRequests,
			date_of_qualifying_event: effectiveDate,
			user_acknowledgement: values.agreement ? YesNoIndicators.Yes : YesNoIndicators.No,
			decline_reason: values.declinedMedicalCoverageReason,
			decline_reason_other: values.declinedMedicalCoverageReasonOther,
		},
		enrollments_edited: {
			M: medicalEdited,
			D: dentalEdited,
		},
		dep_enrollments_edited: dependentsPayload,
	};

	dispatch(postAnnualEnrollment(
		guid,
		verifyPayload,
		(verifyResponse) => {
			const verifyResponseInfo = verifyResponse as AEInfo;

			const availableWorkflowActions = verifyResponseInfo?.form_info?.available_workflow_actions;
			const workflowAction = (availableWorkflowActions?.Process && 'Process') || (availableWorkflowActions?.Submit && 'Submit');

			if (verifyResponseInfo?.api_response?.status === 'OK' && verifyResponseInfo?.processing_messages?.errors?.length < 1) {
				const submitPayload = {
					form_info: {
						change_id: verifyResponseInfo?.form_info?.change_id,
						change_id_signature: verifyResponseInfo?.form_info?.change_id_signature,
						workflow_action: workflowAction,
					},
					global_edited: verifyPayload.global_edited,
					enrollments_edited: verifyPayload.enrollments_edited,
					dep_enrollments_edited: dependentsPayload,
				};

				dispatch(postAnnualEnrollment(
					guid,
					submitPayload,
					(submitResponse) => {
						const submitResponseInfo = submitResponse as AEInfo;

						dispatch(setAEInfo(submitResponseInfo, app));
						sessionStorage?.removeItem(`${createNewForm}-${guid}`);
						callBack();
					},
					null,
					groupId,
				));
			} else {
				dispatch(setAEInfo(verifyResponseInfo, app));
				callBack();
			}
		},
		null,
		groupId,
	));
}
